import { c as _c } from "react/compiler-runtime";
import StarHalfIcon from '@eversports/design-tokens/assets/icons/solid/star-half.svg?icon';
import StarIcon from '@eversports/design-tokens/assets/icons/solid/star.svg?icon';
import { cn } from '@eversports/klimt-design-components/tailwind/utils';
import Image from 'next/image';
import { QUARTER_STAR_ICON, THREE_QUARTER_STAR_ICON } from '../../App.icons';
export enum StarVariant {
  FILLED = 'FILLED',
  EMPTY = 'EMPTY',
  HALF = 'HALF',
  QUARTER = 'QUARTER',
  THREE_QUARTER = 'THREE_QUARTER',
}
const PartialStarIconMapping: { [key in Exclude<StarVariant, StarVariant.FILLED | StarVariant.EMPTY | StarVariant.HALF>]: string } = {
  [StarVariant.QUARTER]: QUARTER_STAR_ICON,
  [StarVariant.THREE_QUARTER]: THREE_QUARTER_STAR_ICON
};
interface StarProps {
  variant: StarVariant;
  size: 'regular' | 'small';
}
const Star = t0 => {
  const $ = _c(14);
  const {
    variant,
    size
  } = t0;
  if (variant === StarVariant.FILLED || variant === StarVariant.EMPTY) {
    const t1 = size === "small" ? "size-1" : "size-2";
    const t2 = variant === StarVariant.FILLED ? "text-surface-brand-tertiary" : "text-text-disabled";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
      t3 = cn(t1, t2);
      $[0] = t1;
      $[1] = t2;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== t3) {
      t4 = <StarIcon className={t3} aria-hidden={true} />;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  if (variant === StarVariant.HALF) {
    const t1 = size === "small" ? "size-1" : "size-auto";
    let t2;
    if ($[5] !== t1) {
      t2 = cn("text-surface-brand-tertiary", t1);
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== t2) {
      t3 = <StarHalfIcon className={t2} aria-hidden={true} />;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  const t1 = PartialStarIconMapping[variant];
  const t2 = size === "small" ? "size-1" : "size-auto";
  let t3;
  if ($[9] !== t2) {
    t3 = cn(t2);
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t3) {
    t4 = <Image src={t1} alt="" className={t3} />;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default Star;